import {
  NotificationActionTypes,
  FetchRequestAction,
  FetchSuccessAction,
  FetchErrorAction,
} from './types';
import {
  FetchNotificationResponseData,
  FetchNotificationParam,
} from '../../api/types';

export const fetchRequest = (
  data: FetchNotificationParam,
): FetchRequestAction => {
  return {
    type: NotificationActionTypes.FETCH_REQUEST,
  };
};

export const fetchSuccess = (
  data: FetchNotificationResponseData,
): FetchSuccessAction => {
  return {
    type: NotificationActionTypes.FETCH_SUCCESS,
    payload: data,
  };
};

export const fetchError = (errors: {
  status: number;
  data: string;
}): FetchErrorAction => {
  return {
    type: NotificationActionTypes.FETCH_ERROR,
    payload: errors,
  };
};
